import { type FC, useEffect, useRef } from "react";

import * as CSS from "./page-tabs.styles";
import type { PageTabsProps } from "./page-tabs.types";

type PageTabsCollectionProps = {
	pages: PageTabsProps[];
	activeId: string;
	onClick: (id: string) => void;
};

const PageTabs: FC<PageTabsCollectionProps> = ({
	onClick,
	pages,
	activeId,
}) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		containerRef.current
			?.querySelector(`[data-id="${activeId}"]`)
			?.scrollIntoView({
				behavior: "smooth",
				inline: "nearest",
				block: "nearest",
			});
	}, [activeId]);

	return (
		<CSS.PageTabs ref={containerRef}>
			{pages.map((page) => (
				<CSS.TitleContainer key={page.id} data-id={page.id}>
					<CSS.Title
						$active={activeId === page.id}
						onClick={() => onClick(page.id)}
					>
						{page.title}
					</CSS.Title>
				</CSS.TitleContainer>
			))}
		</CSS.PageTabs>
	);
};

export default PageTabs;
